import { AlloyButton, WarningOutlineIcon } from 'cat-ecommerce-alloy';
import { PROP_65_WARNING } from '@app/components/pages/pdp/ProductDisplayPage/constant';
import WarningPopup from '@app/components/common/WarningPopup';
import styles from './CustomizeModalTable.module.scss';
export const getProp65Information = (prop65, title) => {
  const productWarningInitiator = (
    <AlloyButton
      buttonType="ghost"
      size="small"
      className={`p-0 my-1 d-flex align-items-center text-sans-serif text-start text-transform-none u-fs--12 ${styles['warningButton']}`}
    >
      <WarningOutlineIcon className="me-2" />
      {PROP_65_WARNING}
    </AlloyButton>
  );
  return (
    prop65 && (
      <WarningPopup
        warnings={[
          {
            title,
            message: prop65
          }
        ]}
        initiator={productWarningInitiator}
      />
    )
  );
};
